"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullcalendarNativeModes = exports.fullcalendarViewMode = exports.FullcalendarViewModes = void 0;
exports.FullcalendarViewModes = {
    Day: "timeGrid",
    Week: "timeGridWeek",
    Month: "dayGridMonth",
    Year: "monthGridYear",
    List: "listWeek",
};
exports.fullcalendarViewMode = [
    exports.FullcalendarViewModes.Day,
    exports.FullcalendarViewModes.Week,
    exports.FullcalendarViewModes.Month,
    exports.FullcalendarViewModes.Year,
    exports.FullcalendarViewModes.List,
];
exports.fullcalendarNativeModes = [
    exports.FullcalendarViewModes.Day,
    exports.FullcalendarViewModes.Week,
    exports.FullcalendarViewModes.Month,
    exports.FullcalendarViewModes.List,
];
